import {Collapse, TextField} from "@mui/material";
import React from "react";

const ProjectDetailTemplateNameField = ({
                                          showTemplateNewField,
                                          draftQuoteDetail,
                                          handleTemplateNameChange,
                                          error
                                      }) =>
{
    return (
        <Collapse in={showTemplateNewField}>
            <TextField
                id="template-name"
                label="Give the template a name"
                error={!!error}
                required={showTemplateNewField}
                helperText={error ? error : ""}
                value={draftQuoteDetail.templateName || ''}
                size={"small"}
                onChange={handleTemplateNameChange}
                sx={{ width: {xs: '250px !important', md: '300px !important'},
                    my: 2,
                    ml: 2
                }}
            />
        </Collapse>
    )
}

export default ProjectDetailTemplateNameField;